import React, { FC } from 'react'

import { SignUpStates } from 'Hooks/checkout'
import { Inquiry } from 'Utils/inquiry'

import { Details } from './Details'
import { Password } from './Password'

interface Props {
  showDetails: boolean
  state: Inquiry<SignUpStates>
}

export const Identify: FC<Props> = ({ showDetails, state }) => {
  const activeSection = state.isPassword ? 'password' : 'details'
  let activeSectionTitle: string | null = null
  let activeSectionDescription: string | null = null

  if (state.isPassword) {
    activeSectionTitle = 'Welcome Back'
    activeSectionDescription = 'Sign in to continue with your saved customer profile'
  } else if (showDetails) {
    activeSectionTitle = 'Contact Details'
    activeSectionDescription = 'Add your contact details to continue'
  }

  return (
    <section className="user-profile-login__panel user-profile-login__panel_active" data-step={activeSection}>
      {activeSectionTitle ? <h3 className="user-profile-login__title">{activeSectionTitle}</h3> : null}
      {activeSectionDescription ? <p className="user-profile-login__description">{activeSectionDescription}</p> : null}

      {showDetails ? <Details state={state} /> : null}
      {state.isPassword ? <Password /> : null}
    </section>
  )
}
